import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Tab, Tabs } from '@rossum/ui/material';
import {
  MenuItem,
  visibleMenuItemsForTab,
} from '../../components/NavBar/navigationStructure';
import { userRoleNameSelector } from '../../redux/modules/user/selectors';
import { useAccessibleFeatures } from './hooks/useAccessibleFeatures';

/**
 * HeaderTabs component returns tabs that are generated from menu items from navigation structure
 * This lets you sync names and permissions for free.
 */

export const HeaderTabs = <T extends MenuItem>({
  menuItems,
  value,
  dataCy,
}: {
  menuItems: T[];
  value: T['name'];
  dataCy?: string;
}) => {
  const intl = useIntl();
  const { push } = useHistory();

  const features = useAccessibleFeatures();
  const role = useSelector(userRoleNameSelector);
  const tabs = visibleMenuItemsForTab(menuItems ?? [], features, role);

  return (
    <Tabs
      data-cy={dataCy}
      value={value}
      onChange={(_, newValue) => {
        const link = tabs.find(tab => tab.name === newValue)?.link;
        if (link) {
          push(link);
        }
      }}
    >
      {tabs.map(tab => (
        <Tab
          key={tab.name}
          label={intl.formatMessage({
            id: `components.appBar.menu.${tab.translationKey}`,
          })}
          data-cy={`tab-${tab.translationKey}`}
          value={tab.name}
        />
      ))}
    </Tabs>
  );
};
